module.exports = __webpack_public_path__ + "static/media/trashone.127f8c8d.svg";